var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTelegram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 512,
    height: 512,
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_286",
    "data-name": "Raggruppa 286",
    transform: "translate(-6109 -10021)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_285",
    "data-name": "Raggruppa 285"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_284",
    "data-name": "Raggruppa 284"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_283",
    "data-name": "Raggruppa 283"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_778",
    "data-name": "Tracciato 778",
    d: "M256,512c141.385,0,256-114.615,256-256S397.385,0,256,0,0,114.615,0,256,114.615,512,256,512Z",
    transform: "translate(6109 10021)",
    fill: "#26a3e1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_779",
    "data-name": "Tracciato 779",
    d: "M115.881,253.3q111.943-48.772,149.293-64.307c71.094-29.571,85.867-34.708,95.495-34.877,2.118-.037,6.853.487,9.92,2.976a10.786,10.786,0,0,1,3.644,6.933,45.183,45.183,0,0,1,.428,10.078c-3.853,40.479-20.523,138.713-29,184.051-3.588,19.184-10.654,25.616-17.5,26.246-14.866,1.368-26.155-9.825-40.554-19.264-22.531-14.769-35.26-23.963-57.131-38.376-25.275-16.656-8.89-25.81,5.514-40.771,3.77-3.915,69.272-63.494,70.539-68.9.159-.676.306-3.195-1.191-4.526s-3.706-.875-5.3-.514q-3.39.77-107.982,71.373-15.326,10.523-27.763,10.255c-9.14-.2-26.723-5.169-39.794-9.418-16.032-5.211-28.774-7.966-27.664-16.817Q97.7,260.526,115.881,253.3Z",
    transform: "translate(6109 10021)",
    fill: "#fff",
    fillRule: "evenodd"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelegram);
export default __webpack_public_path__ + "static/media/telegram.329c1c9ede5a3ff49caed685502defa1.svg";
export { ForwardRef as ReactComponent };